import { defineComponent as r, computed as n, openBlock as o, createElementBlock as c, createElementVNode as l } from "vue";
import { SPINNER_SIZES as a } from "./types.mjs";
const m = ["width", "height"], p = ["stroke-width"], f = /* @__PURE__ */ r({
  __name: "IstSpinner",
  props: {
    thickness: { default: 5 },
    size: { default: "1em" }
  },
  setup(i) {
    const t = i, s = n(() => {
      if (!t.size)
        return "1rem";
      let e = a[t.size];
      return e || (e = t.size), e;
    });
    return (e, h) => (o(), c("svg", {
      class: "ist-spinner ist-spinner-mat",
      width: s.value,
      height: s.value,
      viewBox: "25 25 50 50"
    }, [
      l("circle", {
        class: "path",
        cx: "50",
        cy: "50",
        r: "20",
        fill: "none",
        stroke: "currentColor",
        "stroke-width": e.thickness,
        "stroke-miterlimit": "10"
      }, null, 8, p)
    ], 8, m));
  }
});
export {
  f as default
};
